module.exports = __webpack_public_path__ + "static/img/Forest.13420b5.png";